export const CONFIG_CAT_INIT_TIMEOUT_MESSAGE =
  "The underlying ConfigCat client could not initialize within maxInitWaitTimeSeconds.";

export function isConfigCatInitTimeoutError(error: unknown): error is Error {
  return error instanceof Error && error.message === CONFIG_CAT_INIT_TIMEOUT_MESSAGE;
}
